import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { applyKey } from "../../utils";
import {
  LeadTitle,
  PassoContent,
  PassoImageMobile,
  PassosContainer,
} from "./PassosEnumerados.Style";
import { Image, Text } from "../common";

const Passo = ({ imgSrc, imgAlt, children: body, numeroPasso, titulo }) => (
  <PassoContent>
    <PassoImageMobile as={Image} src={imgSrc} alt={imgAlt} />
    <div>
      {titulo || (
        <LeadTitle as={Text} text={`${numeroPasso}º passo`} textType="lead" />
      )}
      {body}
    </div>
  </PassoContent>
);

Passo.defaultProps = {
  numeroPasso: 0,
  titulo: null,
};

Passo.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  imgAlt: PropTypes.string.isRequired,
  numeroPasso: PropTypes.number,
  titulo: PropTypes.element,
};

const PassosEnumerados = (props) => {
  const { contentItems, children } = props;

  const childrenPassos = useMemo(() => React.Children.toArray(children), [
    children,
  ]);

  const passos = useMemo(
    () =>
      applyKey(contentItems, ({ imgSrc, imgAlt, body }) => (
        <Passo imgSrc={imgSrc} imgAlt={imgAlt}>
          {body}
        </Passo>
      )),
    [contentItems]
  );

  return (
    <PassosContainer {...props}>
      {applyKey(passos.concat(childrenPassos), (passo, numeroPasso) =>
        React.cloneElement(passo, { numeroPasso: numeroPasso + 1 })
      )}
    </PassosContainer>
  );
};

PassosEnumerados.defaultProps = {
  contentItems: [],
  linhaInversa: "odd",
};

PassosEnumerados.propTypes = {
  contentItems: PropTypes.arrayOf(
    PropTypes.shape({ ...Passo.propTypes, body: PropTypes.element.isRequired })
  ),
  linhaInversa: PropTypes.oneOf(["even", "odd"]),
};

PassosEnumerados.Passo = Passo;

export default PassosEnumerados;
